import { useSelector } from 'react-redux';
import { useSitemap } from 'ws-scripts/modules/common';
import {
	FRAGMENT_STATUS,
	selectFragmentStatus
} from '../features/fragmentsSlice';

/**
 * Resolves a sitemap fragment alias to its URL and reports whether that
 * fragment's Redux status has reached LOADED -- the sitemap.get +
 * selectFragmentStatus + `=== FRAGMENT_STATUS.LOADED` sequence
 * MyCarsHeaderIcon (which owns the fetch) and DrawerCTAButtons (which
 * doesn't, but depends on the same fragment having loaded) each derived
 * independently before this hook existed (US2059853 T71).
 *
 * @param {string} alias - sitemap alias for the fragment page
 * @returns {{ fragmentUrl: string, isLoaded: boolean }}
 */
const useFragmentLoaded = (alias) => {
	const sitemap = useSitemap();
	const fragmentUrl = sitemap.get(alias);
	const status = useSelector((state) =>
		selectFragmentStatus(state, fragmentUrl)
	);

	return { fragmentUrl, isLoaded: status === FRAGMENT_STATUS.LOADED };
};

export default useFragmentLoaded;
